import { Col } from 'antd';
import { Row } from 'antd';
import { Modal } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomTable from '../../../v2-components/Antd/Table';
import { CustomNotification } from '../../../v2-components/Notification';
import CustomMediaViewer from '../../../v2-components/CustomMediaViewer';
import { Service } from '../service';
import CustomButton from '../../../v2-components/Antd/Button';
import LoadingModal from '../../../v2-components/LoadingModal';
import DropdownTable from './components/DropdownTable';
import RecipeModal from './components/RecipeModal';
import EditQuantityModal from './components/EditQuantityModal';
import StatusCard from './components/StatusCard';
import TrackingProgress from './components/TrackingProgress';
import { dictionaryInformation } from './constants/dictionary-information.constant';
import { acceptPayloadAdapter } from './handle/adapter-accept-payload.handle';
import { cancelOrderAdapter } from './handle/adapter-cancel-order-payload.handle';
import { acceptQfPayloadAdapter } from './handle/adapter-qf-payload.handle';
import { rejectPayloadAdapter } from './handle/adapter-reject-payload.handle';
import { checkProducts } from './handle/check-products.handle';
import { checkRetirement } from './handle/check-retirement.handle';
import { clientInfoAdapter } from './handle/client-info-adapter.handle';
import { generateHomeDeliveryInfoColumns } from './handle/generate-home-delivery-columns.handle';
import { generateOrderDetailColumns } from './handle/generate-order-detail-columns.handle';
import { generatePaymentColumns } from './handle/generate-payment-columns.handle';
import { generateProductColumns } from './handle/generate-product-columns.handle';
import { generateClientColumns } from './handle/gererate-client-columns.handle';
import { homeDeliveryInfoAdapter } from './handle/home-delivery-info-adapter.handle';
import { orderDetailInfoAdapter } from './handle/order-detail-info-adapter.handle';
import { paymentInfoAdapter } from './handle/payment-info-adapter.handle';
import { productInfoAdapter } from './handle/product-info-adapter';
import { approveOrderAdapter } from './handle/adapter-approve-order-payload.handle';
import { checkApproveRecipe } from './handle/check-approved-recipe.handle';
import { changeQuantityProduct } from './handle/change-quantity-product.handle';
import { checkRol } from './handle/check-rol.handle';
import { checkStatus } from './handle/check-status.handle';
import Loading from '../../../v2-components/Loading';

import './style.scss';
import { generateBillingColumns } from './handle/generate-billing-columns.handle';
import { billingInfoAdapter } from './handle/biling-info-adapter.handle';
import { generateBillingSecondColumn } from './handle/generate-billing-second-column.handle';
import { generateBillingThirdColumn } from './handle/generate-billing-third-column.handle';
import ShareOrderModal from './components/ShareOrderModal';

export default function OrderDetailPage() {
	const { pharmacy, id } = useParams();
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setError] = useState(false);
	const [openRecipe, setOpenRecipe] = useState(false);
	const [recipe, setRecipe] = useState();
	const [recipeInfo, setRecipeInfo] = useState();
	const [openEditQuantity, setOpenEditQuantity] = useState(false);
	// const [quantityInfo, setQuantityInfo] = useState();
	const [renderData, setRenderData] = useState(false);
	const [approveQfHistory, setApproveQfHistory] = useState(null);
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [openShareModal, setOpenShareModal] = useState(false); 
  const [isSharing, setIsSharing] = useState(false);
	const [openPaymentVoucherModal, setOpenPaymentVoucherModal] = useState(false);
	const [paymentVoucherUrl, setPaymentVoucherUrl] = useState(null);

	const status = data?.tracking?.[0]?.status;
	const dataTracking = data?.tracking[0];
	const dataOrder = data?.order[0];
	const statusNumber = dataTracking?.status?.status;
	const quotation = data?.quotation
	const { email, token } = GetLocalStorageValue('userInfo');


	useEffect(() => {
		console.log('useEffect pagina principal');
		Promise.all([new Service().getDataById(id, pharmacy), new Service().getApproveRegister(pharmacy, 1)])
			.then(([dataResponse, approveResponse]) => {
				setData(dataResponse);
				setIsLoading(false);
				setRenderData(false);
				setApproveQfHistory(approveResponse?.data);
			})
			.catch((error) => {
				setError(true);
			});
	}, [id, pharmacy, renderData]);

	const handleApproveRecipe = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.setRecipeValue(acceptPayloadAdapter(dataTracking.trx_id, recipeInfo?.code_internal, email))
			.then((response) => {
				console.log('responseApprove', response);
				setOpenRecipe(false);
				setRenderData(true);
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Receta aprobada', description: 'La receta fue aprobada con exito' });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleApproveQf = (approveQfReason, observationsQf) => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.setRecipeValue(acceptQfPayloadAdapter(dataTracking.trx_id, recipeInfo?.code_internal, approveQfReason, email, observationsQf))
			.then((response) => {
				setOpenRecipe(false);
				setRenderData(true);
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Receta aprobada', description: 'La receta fue aprobada con exito' });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleReject = (rejectReason, observations) => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.setRecipeValue(rejectPayloadAdapter(dataTracking.trx_id, recipeInfo?.code_internal, rejectReason, observations, email))
			.then((response) => {
				setOpenRecipe(false);
				setRenderData(true);
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Receta rechazada', description: 'La receta fue rechazada con exito' });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleCancelOrder = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.saveStatus(cancelOrderAdapter(dataTracking.trx_id, pharmacy))
			.then((response) => {
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Estado de la orden', description: 'Cambio realizado con exito' });
				setRenderData(true);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleApproveOrder = () => {
		if (checkApproveRecipe(dataOrder.products)) {
			setOpenLoadingModal(true);
			setIsLoadingModal(true);
			new Service()
				.saveStatus(approveOrderAdapter(dataTracking.trx_id, status?.status, pharmacy))
				.then((response) => {
					setIsLoadingModal(false);
					setOpenLoadingModal(false);
					CustomNotification({ type: 'success', message: 'Estado de la orden', description: 'Cambio realizado con éxito' });
					setRenderData(true);
				})
				.catch((error) => {
					console.log(error);
				});
			return true;
		}
		return CustomNotification({ type: 'error', message: 'Recetas pendientes', description: 'Tienes recetas pendientes de aprobación' });
	};

	const handleSendOrder = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.resendEmail(id)
			.then((response) => {
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Orden enviada', description: 'La orden fue reenviada a su dirección de correo' });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleChangeQuantity = (products) => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.deleteProduct(changeQuantityProduct(dataTracking.trx_id, pharmacy, products))
			.then((response) => {
				if (response.statusCode === 400) {
					setOpenEditQuantity(false);
					setIsLoadingModal(false);
					setOpenLoadingModal(false);
					return CustomNotification({
						type: 'warning',
						message: 'Cancelación registrada',
						description: response.message,
					});
				}
				setOpenEditQuantity(false);
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({
					type: 'success',
					message: 'Operación exitosa',
					description: 'La cantidad de productos se modifico exitósamente',
				});
				setRenderData(true);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleReverseOrder = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.restoreStatus({ email: email, pharmacy: pharmacy, trx_id: dataTracking?.trx_id.toString() })
			.then((response) => {
				if (response.statusCode === 400) {
					setIsLoadingModal(false);
					setOpenLoadingModal(false);
					return CustomNotification({
						type: 'warning',
						message: null,
						description: response.message,
					});
				}
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				setRenderData(true);
				return;
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleOpenRecipe = (recipe, productInfo) => {
		setRecipe(recipe);
		setOpenRecipe(true);
		setRecipeInfo(productInfo);
	};

	const handleOpenQuantity = () => {
		setOpenEditQuantity(true);
	};

	const handleOpenShareModal = () => {
    setOpenShareModal(true);
	};

	const handleOpenPaymentVoucher = (url) => {
		setPaymentVoucherUrl(url);
		setOpenPaymentVoucherModal(true);
	};
	
	const handleShareOrder = (emailTo, selectedIds) => {
    setIsSharing(true);
    const selectedProducts = dataOrder.products.filter(p => selectedIds.includes(p.id));
		console.log('selectedProducts',selectedProducts)

   
    const payload = {
      mail_to: [emailTo],
      product_ids: selectedIds,
    };


    new Service().shareOrder(payload, id, token) 
      .then((response) => {
        setOpenShareModal(false);
        setIsSharing(false);
        CustomNotification({ 
          type: 'success', 
          message: 'Compartido', 
          description: 'La información se ha compartido exitosamente.' 
        });
      })
      .catch((error) => {
        console.error(error);
        setIsSharing(false);
        CustomNotification({ 
          type: 'error', 
          message: 'Error', 
          description: 'No se pudo compartir la información.' 
        });
      });
  };

	if (isError) {
		return (
			<>
				<Row>
					<Col span={8}>
						<h2>Lo sentimos...</h2>
						<h3>{`La Solicitud N° ${id} no existe`} </h3>
						<Link to={checkRol()}>Volver a ordenes</Link>
					</Col>
				</Row>
			</>
		);
	}


	if (isLoading) {
		return <Loading />;
	}
	console.log('order', dataOrder?.payment[0]?.reverse_total);
	return (
		<div className="ph-tracking-order-detail-page-container">
			<Row>
				<Col span={8}>
					<h2>{`Orden de compra N° ${id}`} </h2>
					<Link to={checkRol(data?.tracking[0]?.pharmacy)}>Volver a ordenes</Link>
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<TrackingProgress data={data} />
				</Col>
				<Col span={12}>
					<CustomCard style={{ width: 400 }}>
						<StatusCard
							statusNumber={statusNumber}
							status={status}
							handleCancelOrder={handleCancelOrder}
							handleApproveOrder={handleApproveOrder}
							deliveryType={dataOrder.info.type_retirement}
							handleReverseOrder={handleReverseOrder}
							products={dataOrder.products}
							paymentMethod={paymentInfoAdapter(data)[0].payment_method_name}
						/>
					</CustomCard>
				</Col>
				<Col span={24} style={{ display: checkRetirement(dataOrder.info.type_retirement) }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].home_delivery}</h3>
					<CustomTable columns={generateHomeDeliveryInfoColumns()} pagination={false} dataSource={homeDeliveryInfoAdapter(data)} />
				</Col>
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].client}</h3>
					<CustomButton onClick={handleSendOrder}>REENVIAR ORDEN</CustomButton>
					<CustomTable columns={generateClientColumns()} pagination={false} dataSource={clientInfoAdapter(dataOrder)} />
				</Col>
				{dataOrder?.info?.info_billing && (
					<>
						<Col span={24}>
							<h3>{dictionaryInformation[Enviroment.LANGUAGE].billing}</h3>
							<CustomTable
								columns={generateBillingColumns()}
								pagination={false}
								dataSource={billingInfoAdapter(dataOrder?.info?.info_billing)}
							/>
						</Col>
						<Col span={24} style={{ marginTop: '20px' }}>
							<CustomTable
								columns={generateBillingSecondColumn()}
								pagination={false}
								dataSource={billingInfoAdapter(dataOrder?.info?.info_billing)}
							/>
						</Col>
						<Col span={24} style={{ marginTop: '20px' }}>
							<CustomTable
								columns={generateBillingThirdColumn()}
								pagination={false}
								dataSource={billingInfoAdapter(dataOrder?.info?.info_billing)}
							/>
						</Col>
					</>
				)}
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].order}</h3>
					<CustomTable columns={generateOrderDetailColumns()} pagination={false} dataSource={orderDetailInfoAdapter(data)} />
				</Col>

				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].payment}</h3>
					<CustomButton target="_blank" href={dataTracking?.url_voucher}>
						VER VOUCHER
					</CustomButton>
					<CustomTable columns={generatePaymentColumns(handleOpenPaymentVoucher)} pagination={false} dataSource={paymentInfoAdapter(data)} />
				</Col>

				<Col span={24}>
					<Row justify="space-between" align="middle">
						<h3>{dictionaryInformation[Enviroment.LANGUAGE].products}</h3>
						<CustomButton
							disabled={!isNaN(dataOrder?.payment[0]?.reverse_total) || checkStatus(statusNumber)}
							style={{ marginTop: '40px' }}
							onClick={() => handleOpenQuantity()}
						>
							EDITAR STOCK
						</CustomButton>
						{(Enviroment.COUNTRY === "CL" || Enviroment.COUNTRY === "CLNARMA" || Enviroment.COUNTRY === "CLGREEN") && (
                <CustomButton
                  onClick={handleOpenShareModal}
                >
                  COMPARTIR
                </CustomButton>
              )}
					</Row>
					{checkProducts(dataTracking.status.status, dataOrder.products, dataOrder?.payment[0]?.reverse_total)}
					<CustomTable
						columns={generateProductColumns(handleOpenRecipe, pharmacy)}
						pagination={false}
						dataSource={productInfoAdapter(dataOrder.products, quotation)}
						expandable={{ expandedRowRender: (record) => <DropdownTable status={dataTracking.status.status} record={record} /> }}
					/>
				</Col>

				<RecipeModal
					openRecipe={openRecipe}
					setOpenRecipe={setOpenRecipe}
					trx_id={dataTracking.trx_id}
					recipe={recipe}
					recipeInfo={recipeInfo}
					status={dataTracking.status.status}
					handleApproveRecipe={handleApproveRecipe}
					handleApproveQf={handleApproveQf}
					handleReject={handleReject}
					approveQfHistory={approveQfHistory}
				/>
				<EditQuantityModal
					openEditQuantity={openEditQuantity}
					setOpenEditQuantity={setOpenEditQuantity}
					handleChangeQuantity={handleChangeQuantity}
					products={productInfoAdapter(dataOrder.products, quotation)}
				/>
				<ShareOrderModal
          open={openShareModal}
          onCancel={() => setOpenShareModal(false)}
          onSend={handleShareOrder}
          products={dataOrder?.products?.filter(p => p.category === "Magistral Recipe") || []}
          isLoading={isSharing}
        />
				<Modal
					title="Comprobante de pago"
					open={openPaymentVoucherModal}
					onCancel={() => setOpenPaymentVoucherModal(false)}
					footer={null}
					width={800}
				>
					{paymentVoucherUrl && <CustomMediaViewer src={paymentVoucherUrl} />}
				</Modal>
				<LoadingModal visible={openLoadingModal} loading={isLoadingModal} setVisible={setOpenLoadingModal} />
			</Row>
		</div>
	);
}
